import React from "react";
import _ from "lodash";

import { Modal } from "../ui/Modal";
import FlexBox from "../ui/FlexBox";
import SideBarHeader from "../layout/SideBarHeader";
import * as followUpActions from "../../actions/followUpActions";
import { getCompanyFormatDate, getCompanyFormatTime } from "../../helpers/DateUtils";
import RepeatAppointmentTrxPlanningForm from "../chart/repeat-appointment/RepeatAppointmentTrxPlanningForm";

export default class RequestedDeleteConfirmModal extends React.Component {
  render() {
    const {
      followUp: { showEditForm, item },
      handleRedirectPatientChart,
    } = this.props;

    const initialValues = {
      note: item.note || "",
      note2: item.note2 || "",
      createdDate: item.date || null,
      creator: (item.creator && item.creator.name) || "",
    };

    if (item.doctor && item.doctor.id) {
      initialValues.doctor = item.doctor.id;
    }

    if (item?.type && item.type.id) {
      initialValues.type = item.type.id;
    }

    const renderAppointmentDate = () => {
      const appointmentDate = _.get(item, "appointmentDate");

      if (!appointmentDate) return "";

      return `${getCompanyFormatDate(appointmentDate)} ${getCompanyFormatTime(appointmentDate)}`;
    };

    return (
      <Modal
        show={showEditForm}
        animation={false}
        onHide={() => this.props.dispatch(followUpActions.closeEditForm())}
        dialogClassName="follow-up-side-bar"
      >
        <SideBarHeader
          onClick={() => this.props.dispatch(followUpActions.closeEditForm())}
          addClass="d-flex"
        >
          <FlexBox
            style={{
              backgroundColor: "#9caf46",
              borderRadius: "5px",
              padding: "5px",
              width: "80%",
            }}
          >
            <FlexBox flex={true} className="text-white" direction="column">
              <p className="mb-0">Patient</p>
              <FlexBox className="name" justify={"space-between"}>
                {item.patient?.fullName || ""} <span>{item.patient?.vipPatient && "VIP"}</span>
              </FlexBox>
            </FlexBox>
            <FlexBox flex={true} className="text-white" direction="column">
              <p className="mb-0">Chart No</p>
              <FlexBox className="mb-0">{item.patient?.chartNumber || ""}</FlexBox>
            </FlexBox>
            <FlexBox flex={true} className="text-white" direction="column">
              <p className="mb-0">Appointment</p>
              <FlexBox className="mb-0">{renderAppointmentDate()}</FlexBox>
            </FlexBox>
          </FlexBox>
        </SideBarHeader>
        <div className="follow-up-side-bar-form">
          <RepeatAppointmentTrxPlanningForm
            handleRedirectPatientChart={handleRedirectPatientChart}
            initialValues={initialValues}
            enableReinitialize={true}
            keepDirtyOnReinitialize={true}
            onRepeatClick={this.props.onRepeatClick}
            fromList={true}
          />
        </div>
      </Modal>
    );
  }
}
